import React from 'react';
import { SummaryData } from '@/pages/hettwer/types/OfferDetailsData';

interface SummaryBlockProps {
  summary?: SummaryData;
  onChange: (summary: SummaryData) => void;
}

/**
 * SummaryBlock
 *
 * Editor block for offer summary.
 * Designed to visually and semantically match PositionsBlock.
 */
export const SummaryBlock: React.FC<SummaryBlockProps> = ({ summary, onChange }) => {
  const s: SummaryData = summary ?? {};

  const update = (patch: Partial<SummaryData>) => onChange({ ...s, ...patch });

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Zusammenfassung</h3>
      </div>

      <div className="card-body space-y-5">
        {/* ==================================================
           Subject
           ================================================== */}
        <div className="flex flex-col gap-1">
          <label className="text-xs text-gray-600">Betreff</label>
          <input
            className="input input-sm w-full"
            value={s.subject ?? ''}
            placeholder="Betreff"
            onChange={(e) => update({ subject: e.target.value })}
          />
        </div>

        {/* ==================================================
           Project type
           ================================================== */}
        <div className="flex flex-col gap-1">
          <label className="text-xs text-gray-600">Projektart</label>
          <input
            className="input input-sm w-full"
            value={s.project_type ?? ''}
            placeholder="Projektart"
            onChange={(e) => update({ project_type: e.target.value })}
          />
        </div>

        {/* ==================================================
           Description
           ================================================== */}
        <div className="flex flex-col gap-1">
          <label className="text-xs text-gray-600">Beschreibung</label>
          <textarea
            className="textarea textarea-sm w-full"
            rows={4}
            value={s.description ?? ''}
            placeholder="Kurzbeschreibung des Projekts"
            onChange={(e) => update({ description: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};
